import { cva, type VariantProps } from 'class-variance-authority'
import { ReactNode, RefObject } from 'react'

import { cn } from '@/shared/lib'

const cardVairants = cva(
  [
    'group flex rounded-sm bg-white shadow-[0px_1px_7px_0px_rgba(0,0,0,0.15)]',
    '[&:has(.card-item)]:flex-col [&:has(.card-item)]:px-0',
  ],
  {
    variants: {
      spacing: {
        small: 'flex-col p-6 [&_div.card-item]:px-6',
        large: 'p-10 [&_div.card-item]:px-10',
      },
    },
  },
)

type CommonProps = {
  children: ReactNode
  className?: string
}

type CardProps = CommonProps &
  VariantProps<typeof cardVairants> & {
    ref?: RefObject<HTMLDivElement | null>
  }

export const Root = ({ ref, spacing, children, className }: CardProps) => {
  return (
    <div
      className={cn(cardVairants({ spacing }), className)}
      data-spacing={spacing}
      ref={ref}
    >
      {children}
    </div>
  )
}

export const Item = ({ children, className }: CommonProps) => {
  return (
    <div
      className={cn(
        'card-item flex justify-between border-b border-gray-100 py-[34px]',
        '[&:first-child]:pt-0 [&:last-child]:pb-0',
        '[&:first-child:last-child]:py-0 [&:last-child]:border-none',
        className,
      )}
    >
      {children}
    </div>
  )
}

export const ItemTitle = ({ children, className }: CommonProps) => {
  return (
    <h3
      className={cn(
        'typo-headline3 w-[127px] font-semibold text-black',
        className,
      )}
    >
      {children}
    </h3>
  )
}

export const ItemSubTitle = ({ children, className }: CommonProps) => {
  return (
    <h4
      className={cn(
        'typo-headline3 w-[127px] font-semibold text-gray-400',
        className,
      )}
    >
      {children}
    </h4>
  )
}

export const ItemContent = ({ children, className }: CommonProps) => {
  return (
    <div className={cn('typo-body2 w-[608px] text-black', className)}>
      {children}
    </div>
  )
}
